module.exports = __webpack_public_path__ + "static/media/companynewsImg5.9188146f.jpg";